/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {systemOfUnitsSelector} from '@/store/selectors/login-selectors';
import {showMapScaleWidgetSelector} from '@/store/selectors/tracking-selectors';

/**
 * The useBottomLeftToolProps hook is used for sharing props to Bottom Left Tools
 * 
 * ```typescript
 * 
 *   import useBottomLeftToolProps from './hooks/useBottomLeftToolProps';
 * 
 *   const bottomLeftToolProps = useBottomLeftToolProps();
 * 
 *   // bottomLeftToolProps
 * 
 * ```
 */
export const useBottomLeftToolProps = () => {
  const systemOfUnits      = useSelector(systemOfUnitsSelector);
  const showMapScaleWidget = useSelector(showMapScaleWidgetSelector);

  const bottomLeftToolProps = useMemo(() => {
    return {
      systemOfUnits,
      showMapScaleWidget
    };
  }, [systemOfUnits, showMapScaleWidget]);

  return bottomLeftToolProps;
};

export default useBottomLeftToolProps;
